/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    Teachers: '',
    TeacherStudentData:'',
      Classdetails:'',

  },
  mutations: {
    setTeacherData (state, Teachers) {
      state.Teachers = Teachers
    },
    setTeacherStudentData (state, TeacherStudentData) {
      state.TeacherStudentData = TeacherStudentData
    },
    reset (state) {
      state.TeacherStudentData = ''
      state.Teachers = ''
    },
    setClassData (state, Classdetails) {
        state.Classdetails = Classdetails
    },
  },

  actions: {
    getAllTeachers ({commit}) {
      return new Promise(function (resolve, reject) {
        api.getData('admin/teacher')
        .then((response) => {
          var Teachers = response.data
          commit('setTeacherData', {Teachers})
          resolve(Teachers)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    updateTeacher({commit},adminData){
      return new Promise(function(resolve,reject){
        api.postData("admin/teacher/"+adminData.teacherId, adminData.adminData)
        .then(res => {
          resolve(res)
        })
        .catch(function (error) {
            reject(error)
        })
        api.postData("admin/setTeacherRate",{teacher_id:adminData.teacherId,price_per_module:adminData.amount})
        .then(res => {
          resolve(res)
        })
        .catch(function (error) {
            reject(error)
        })

      })

    },
    AddTeacher({commit}, data) {
      return new Promise(function (resolve, reject) {
        commit('setLoading', {loading: true})
        api.postData('admin/teacher/signup', data).then(res => {
            commit('setLoading', {
              loading: false
            })
            resolve(res)
          })
          .catch((error) => {
            commit('setLoading', {loading: false})
            reject(error)
          })
      })
    },
    changeTeacherStatus({commit},Data){
        api.postData("admin/teacher/status/"+Data.teacherid, {"status":Data.status})
        .then(res => {
        })
        .catch(function (error) {

        })
    },
    setTeachersSchedule({commit},ScheduleData){

        for(var x=0;x<ScheduleData[1].length;x++){
          var length=ScheduleData[1][x].length
          for(var y=0;y<length;y++){
              ScheduleData[1][x][y]=Object.assign({},ScheduleData[1][x][y])
          }
        }
        var passingData={
          day:ScheduleData[0],
          times:ScheduleData[1],
          date_from:ScheduleData[2],
          date_to:ScheduleData[3],
          teacher_id:ScheduleData[4],
        }
        api.postData("admin/calender/teacher/create",passingData)
        .then(res => {
        })
        .catch(function (error) {

        })

    },
    getTeacherById ({commit}, id) {
      if (id) {
        api.getData('admin/teacher/' + id)
        .then(res => {
            var teachers = res.data
            commit('setTeacherData', teachers)
            return teachers
        })
      }
    },
    getTeacherByIdforEdit ({commit}, id) {
        return new Promise(function (resolve, reject) {
          api.getData('admin/teacher/' + id)
          .then(res => {
              var teachers = res.data
              resolve(res)
          }).catch((error) => {
              commit('setLoading', {loading: false})
              reject(error)
            })
        })
    },
    getTeacher_studentById ({commit}, teacher_id) {
      if (teacher_id) {
        api.postData('admin/teacher_students' ,{'teacher_id':teacher_id}).then(
        res => {
          var teachers = res.data
          commit('setTeacherStudentData', teachers)
        })
      }
    },
    cancelBookedClass({commit},data){
      return new Promise(function(resolve,reject){
        api.postData("admin/student_class/teacher_cancel", data)
        .then(res => {
          resolve(res)
        })
        .catch(function (error) {
            reject(error)
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Teachers.js